// import { useState } from 'react'
// import {
//   Box,
//   Button,
//   Checkbox,
//   Chip,
//   IconButton,
//   ListItemIcon,
//   Menu,
//   MenuItem,
//   Paper,
//   Select,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
// } from '@mui/material'
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
// import ChevronRightIcon from '@mui/icons-material/ChevronRight'
// import {
//   PRIMARY,
//   PRIORITIES,
//   STATUSES,
//   STATUS_BY_ID,
//   USERS,
//   USER_BY_ID,
//   checklistProgress,
//   formatDue,
//   formatMinutes,
//   type Priority,
//   type StatusId,
//   type TaskPatch,
//   type TodoTask,
// } from './Tododata.ts'
// import UserAvatar from './Useravtar.tsx'

// interface Props {
//   tasks: TodoTask[] // already filtered
//   /** Single-row edits and bulk actions both go through here. */
//   onUpdate: (ids: string[], patch: TaskPatch) => void
//   onOpen: (task: TodoTask) => void
// }

// type BulkMenu = 'status' | 'assignee' | 'priority'

// const headCell = { color: '#fff', fontWeight: 700, fontSize: 13, borderBottom: 0, py: 1.5 } as const
// const bulkBtn = { color: '#fff', borderColor: 'rgba(255,255,255,0.5)', textTransform: 'none' } as const

// export default function TaskList({ tasks, onUpdate, onOpen }: Props) {
//   const [collapsed, setCollapsed] = useState<Partial<Record<StatusId, boolean>>>({})
//   const [selectedRaw, setSelected] = useState<string[]>([])
//   const [menu, setMenu] = useState<{ type: BulkMenu; anchor: HTMLElement } | null>(null)

//   // Ignore selections that a filter has hidden, so a bulk action never touches invisible rows
//   const visibleIds = tasks.map((t) => t.id)
//   const selected = selectedRaw.filter((id) => visibleIds.includes(id))
//   const allSelected = tasks.length > 0 && selected.length === tasks.length

//   const toggleSelected = (id: string) =>
//     setSelected(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id])

//   const applyBulk = (patch: TaskPatch) => {
//     onUpdate(selected, patch)
//     setMenu(null)
//     setSelected([])
//   }

//   return (
//     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
//       {selected.length > 0 && (
//         <Box
//           role="region"
//           aria-label="Bulk actions"
//           sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1.5, px: 2, py: 1.25, borderRadius: '10px', bgcolor: '#5C5A3B', color: '#fff' }}
//         >
//           <Typography sx={{ fontWeight: 700, fontSize: 14 }}>{selected.length} selected</Typography>
//           <Button size="small" variant="outlined" sx={bulkBtn} onClick={(e) => setMenu({ type: 'status', anchor: e.currentTarget })}>
//             Change status
//           </Button>
//           <Button size="small" variant="outlined" sx={bulkBtn} onClick={(e) => setMenu({ type: 'assignee', anchor: e.currentTarget })}>
//             Reassign
//           </Button>
//           <Button size="small" variant="outlined" sx={bulkBtn} onClick={(e) => setMenu({ type: 'priority', anchor: e.currentTarget })}>
//             Set priority
//           </Button>
//           <Button size="small" onClick={() => setSelected([])} sx={{ ml: 'auto', bgcolor: '#fff', color: '#3B3A2A', textTransform: 'none', fontWeight: 700, '&:hover': { bgcolor: '#F1F0E6' } }}>
//             Clear
//           </Button>

//           <Menu anchorEl={menu?.anchor} open={!!menu} onClose={() => setMenu(null)}>
//             {menu?.type === 'status' &&
//               STATUSES.map((s) => (
//                 <MenuItem key={s.id} onClick={() => applyBulk({ status: s.id })}>
//                   <ListItemIcon>
//                     <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: s.dot }} />
//                   </ListItemIcon>
//                   {s.label}
//                 </MenuItem>
//               ))}
//             {menu?.type === 'assignee' &&
//               USERS.map((u) => (
//                 <MenuItem key={u.id} onClick={() => applyBulk({ assigneeId: u.id })}>
//                   <ListItemIcon>
//                     <UserAvatar user={u} size={22} />
//                   </ListItemIcon>
//                   {u.name}
//                 </MenuItem>
//               ))}
//             {menu?.type === 'priority' &&
//               (Object.keys(PRIORITIES) as Priority[]).map((p) => {
//                 const { Icon, color, label } = PRIORITIES[p]
//                 return (
//                   <MenuItem key={p} onClick={() => applyBulk({ priority: p })}>
//                     <ListItemIcon sx={{ color }}>
//                       <Icon fontSize="small" />
//                     </ListItemIcon>
//                     {label}
//                   </MenuItem>
//                 )
//               })}
//           </Menu>
//         </Box>
//       )}

//       <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: '8px', borderColor: '#E2DFD0' }}>
//         <Table sx={{ minWidth: 1000 }} size="small">
//           <TableHead>
//             <TableRow sx={{ bgcolor: PRIMARY }}>
//               <TableCell padding="checkbox" sx={{ ...headCell, width: 48 }}>
//                 <Checkbox
//                   checked={allSelected}
//                   indeterminate={selected.length > 0 && !allSelected}
//                   onChange={() => setSelected(allSelected ? [] : visibleIds)}
//                   inputProps={{ 'aria-label': 'Select all tasks' }}
//                   sx={{ color: '#fff', '&.Mui-checked, &.MuiCheckbox-indeterminate': { color: '#fff' } }}
//                 />
//               </TableCell>
//               <TableCell sx={{ ...headCell, width: 96 }}>Key</TableCell>
//               <TableCell sx={headCell}>Task</TableCell>
//               <TableCell sx={{ ...headCell, width: 170 }}>Status</TableCell>
//               <TableCell sx={{ ...headCell, width: 170 }}>Assignee</TableCell>
//               <TableCell sx={{ ...headCell, width: 110 }}>Priority</TableCell>
//               <TableCell sx={{ ...headCell, width: 110 }}>Checklist</TableCell>
//               <TableCell sx={{ ...headCell, width: 110 }}>Hours</TableCell>
//               <TableCell sx={{ ...headCell, width: 90 }}>Due</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {STATUSES.map((status) => {
//               const rows = tasks.filter((t) => t.status === status.id)
//               const isCollapsed = !!collapsed[status.id]
//               return [
//                 <TableRow
//                   key={`g-${status.id}`}
//                   hover
//                   onClick={() => setCollapsed((c) => ({ ...c, [status.id]: !c[status.id] }))}
//                   sx={{ bgcolor: status.columnBg, cursor: 'pointer' }}
//                 >
//                   <TableCell colSpan={9} sx={{ py: 0.5 }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: status.ink }}>
//                       <IconButton size="small" aria-label={isCollapsed ? `Expand ${status.label}` : `Collapse ${status.label}`} aria-expanded={!isCollapsed} sx={{ color: 'inherit' }}>
//                         {isCollapsed ? <ChevronRightIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
//                       </IconButton>
//                       <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: status.dot }} />
//                       <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
//                         {status.label}
//                       </Typography>
//                       <Chip size="small" label={rows.length} sx={{ height: 20, bgcolor: status.pillBg, color: status.ink, fontWeight: 700 }} />
//                     </Box>
//                   </TableCell>
//                 </TableRow>,

//                 ...(isCollapsed
//                   ? []
//                   : rows.map((task) => {
//                       const pri = PRIORITIES[task.priority]
//                       const s = STATUS_BY_ID[task.status]
//                       const user = USER_BY_ID[task.assigneeId]
//                       const { done, total } = checklistProgress(task)
//                       return (
//                         <TableRow key={task.id} hover selected={selected.includes(task.id)} sx={{ '&:last-child td': { borderBottom: 0 } }}>
//                           <TableCell padding="checkbox">
//                             <Checkbox
//                               checked={selected.includes(task.id)}
//                               onChange={() => toggleSelected(task.id)}
//                               inputProps={{ 'aria-label': `Select ${task.title}` }}
//                               sx={{ color: '#8A8468', '&.Mui-checked': { color: PRIMARY } }}
//                             />
//                           </TableCell>
//                           <TableCell sx={{ fontWeight: 700, color: '#55533C' }}>{task.key}</TableCell>
//                           <TableCell
//                             onClick={() => onOpen(task)}
//                             sx={{ fontWeight: 500, fontSize: 14, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
//                           >
//                             {task.title}
//                           </TableCell>
//                           <TableCell>
//                             <Select
//                               size="small"
//                               value={task.status}
//                               onChange={(e) => onUpdate([task.id], { status: e.target.value as StatusId })}
//                               inputProps={{ 'aria-label': `Status for ${task.title}` }}
//                               sx={{
//                                 bgcolor: s.pillBg,
//                                 color: s.ink,
//                                 fontSize: 12,
//                                 fontWeight: 700,
//                                 borderRadius: '6px',
//                                 minWidth: 130,
//                                 '& .MuiOutlinedInput-notchedOutline': { border: 0 },
//                                 '& .MuiSelect-select': { py: 0.5 },
//                                 '& .MuiSvgIcon-root': { color: s.ink },
//                               }}
//                             >
//                               {STATUSES.map((opt) => (
//                                 <MenuItem key={opt.id} value={opt.id} sx={{ fontSize: 13 }}>
//                                   <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: opt.dot, mr: 1 }} />
//                                   {opt.label}
//                                 </MenuItem>
//                               ))}
//                             </Select>
//                           </TableCell>
//                           <TableCell>
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                               <UserAvatar user={user} size={26} />
//                               <Typography sx={{ fontSize: 13 }}>{user?.name ?? 'Unassigned'}</Typography>
//                             </Box>
//                           </TableCell>
//                           <TableCell>
//                             <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, color: pri.color, fontWeight: 600, fontSize: 13 }}>
//                               <pri.Icon sx={{ fontSize: 18 }} />
//                               {pri.label}
//                             </Box>
//                           </TableCell>
//                           <TableCell sx={{ color: '#6B6955', fontSize: 13 }}>
//                             {done}/{total} items
//                           </TableCell>
//                           <TableCell sx={{ color: '#6B6955', fontSize: 13 }}>{formatMinutes(task.timeSpentMinutes)}</TableCell>
//                           <TableCell sx={{ color: '#6B6955', fontSize: 13 }}>{formatDue(task.dueDate)}</TableCell>
//                         </TableRow>
//                       )
//                     })),
//               ]
//             })}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Box>
//   )
// }

import { useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Chip,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import {
  PRIMARY,
  PRIORITIES,
  STATUSES,
  STATUS_BY_ID,
  USERS,
  USER_BY_ID,
  checklistProgress,
  formatDue,
  formatMinutes,
  type Priority,
  type StatusId,
  type TaskPatch,
  type TodoTask,
} from './Tododata.ts'
import UserAvatar from './Useravtar.tsx'
import AssigneeStack from './AssineeStack.tsx'

interface Props {
  tasks: TodoTask[] // already filtered
  /** Single-row edits and bulk actions both go through here. */
  onUpdate: (ids: string[], patch: TaskPatch) => void
  onOpen: (task: TodoTask) => void
}

type BulkMenu = 'status' | 'assignee' | 'priority'

const headCell = { color: '#fff', fontWeight: 700, fontSize: 13, borderBottom: 0, py: 1.5 } as const
const bulkBtn = { color: '#fff', borderColor: 'rgba(255,255,255,0.5)', textTransform: 'none' } as const

export default function TaskList({ tasks, onUpdate, onOpen }: Props) {
  const [collapsed, setCollapsed] = useState<Partial<Record<StatusId, boolean>>>({})
  const [selectedRaw, setSelected] = useState<string[]>([])
  const [menu, setMenu] = useState<{ type: BulkMenu; anchor: HTMLElement } | null>(null)

  // Ignore selections that a filter has hidden, so a bulk action never touches invisible rows
  const visibleIds = tasks.map((t) => t.id)
  const selected = selectedRaw.filter((id) => visibleIds.includes(id))
  const allSelected = tasks.length > 0 && selected.length === tasks.length

  const toggleSelected = (id: string) =>
    setSelected(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id])

  const applyBulk = (patch: TaskPatch) => {
    onUpdate(selected, patch)
    setMenu(null)
    setSelected([])
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {selected.length > 0 && (
        <Box
          role="region"
          aria-label="Bulk actions"
          sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1.5, px: 2, py: 1.25, borderRadius: '10px', bgcolor: '#5C5A3B', color: '#fff' }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: 14 }}>{selected.length} selected</Typography>
          <Button size="small" variant="outlined" sx={bulkBtn} onClick={(e) => setMenu({ type: 'status', anchor: e.currentTarget })}>
            Change status
          </Button>
          <Button size="small" variant="outlined" sx={bulkBtn} onClick={(e) => setMenu({ type: 'assignee', anchor: e.currentTarget })}>
            Reassign
          </Button>
          <Button size="small" variant="outlined" sx={bulkBtn} onClick={(e) => setMenu({ type: 'priority', anchor: e.currentTarget })}>
            Set priority
          </Button>
          <Button size="small" onClick={() => setSelected([])} sx={{ ml: 'auto', bgcolor: '#fff', color: '#3B3A2A', textTransform: 'none', fontWeight: 700, '&:hover': { bgcolor: '#F1F0E6' } }}>
            Clear
          </Button>

          <Menu anchorEl={menu?.anchor} open={!!menu} onClose={() => setMenu(null)}>
            {menu?.type === 'status' &&
              STATUSES.map((s) => (
                <MenuItem key={s.id} onClick={() => applyBulk({ status: s.id })}>
                  <ListItemIcon>
                    <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: s.dot }} />
                  </ListItemIcon>
                  {s.label}
                </MenuItem>
              ))}
            {menu?.type === 'assignee' &&
              USERS.map((u) => (
                <MenuItem key={u.id} onClick={() => applyBulk({ assigneeId: u.id })}>
                  <ListItemIcon>
                    <UserAvatar user={u} size={22} />
                  </ListItemIcon>
                  {u.name}
                </MenuItem>
              ))}
            {menu?.type === 'priority' &&
              (Object.keys(PRIORITIES) as Priority[]).map((p) => {
                const { Icon, color, label } = PRIORITIES[p]
                return (
                  <MenuItem key={p} onClick={() => applyBulk({ priority: p })}>
                    <ListItemIcon sx={{ color }}>
                      <Icon fontSize="small" />
                    </ListItemIcon>
                    {label}
                  </MenuItem>
                )
              })}
          </Menu>
        </Box>
      )}

      <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: '8px', borderColor: '#E2DFD0' }}>
        <Table sx={{ minWidth: 1000 }} size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: PRIMARY }}>
              <TableCell padding="checkbox" sx={{ ...headCell, width: 48 }}>
                <Checkbox
                  checked={allSelected}
                  indeterminate={selected.length > 0 && !allSelected}
                  onChange={() => setSelected(allSelected ? [] : visibleIds)}
                  inputProps={{ 'aria-label': 'Select all tasks' }}
                  sx={{ color: '#fff', '&.Mui-checked, &.MuiCheckbox-indeterminate': { color: '#fff' } }}
                />
              </TableCell>
              <TableCell sx={{ ...headCell, width: 96 }}>Key</TableCell>
              <TableCell sx={headCell}>Task</TableCell>
              <TableCell sx={{ ...headCell, width: 170 }}>Status</TableCell>
              <TableCell sx={{ ...headCell, width: 230 }}>Assignees</TableCell>
              <TableCell sx={{ ...headCell, width: 110 }}>Priority</TableCell>
              <TableCell sx={{ ...headCell, width: 110 }}>Checklist</TableCell>
              <TableCell sx={{ ...headCell, width: 110 }}>Hours</TableCell>
              <TableCell sx={{ ...headCell, width: 90 }}>Due</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {STATUSES.map((status) => {
              const rows = tasks.filter((t) => t.status === status.id)
              const isCollapsed = !!collapsed[status.id]
              return [
                <TableRow
                  key={`g-${status.id}`}
                  hover
                  onClick={() => setCollapsed((c) => ({ ...c, [status.id]: !c[status.id] }))}
                  sx={{ bgcolor: status.columnBg, cursor: 'pointer' }}
                >
                  <TableCell colSpan={9} sx={{ py: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: status.ink }}>
                      <IconButton size="small" aria-label={isCollapsed ? `Expand ${status.label}` : `Collapse ${status.label}`} aria-expanded={!isCollapsed} sx={{ color: 'inherit' }}>
                        {isCollapsed ? <ChevronRightIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
                      </IconButton>
                      <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: status.dot }} />
                      <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                        {status.label}
                      </Typography>
                      <Chip size="small" label={rows.length} sx={{ height: 20, bgcolor: status.pillBg, color: status.ink, fontWeight: 700 }} />
                    </Box>
                  </TableCell>
                </TableRow>,

                ...(isCollapsed
                  ? []
                  : rows.map((task) => {
                      const pri = PRIORITIES[task.priority]
                      const s = STATUS_BY_ID[task.status]
                      const people = task.assigneeIds.map((id) => USER_BY_ID[id]).filter(Boolean)
                      const { done, total } = checklistProgress(task)
                      return (
                        <TableRow key={task.id} hover selected={selected.includes(task.id)} sx={{ '&:last-child td': { borderBottom: 0 } }}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={selected.includes(task.id)}
                              onChange={() => toggleSelected(task.id)}
                              inputProps={{ 'aria-label': `Select ${task.title}` }}
                              sx={{ color: '#8A8468', '&.Mui-checked': { color: PRIMARY } }}
                            />
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700, color: '#55533C' }}>{task.key}</TableCell>
                          <TableCell
                            onClick={() => onOpen(task)}
                            sx={{ fontWeight: 500, fontSize: 14, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                          >
                            {task.title}
                          </TableCell>
                          <TableCell>
                            <Select
                              size="small"
                              value={task.status}
                              onChange={(e) => onUpdate([task.id], { status: e.target.value as StatusId })}
                              inputProps={{ 'aria-label': `Status for ${task.title}` }}
                              sx={{
                                bgcolor: s.pillBg,
                                color: s.ink,
                                fontSize: 12,
                                fontWeight: 700,
                                borderRadius: '6px',
                                minWidth: 130,
                                '& .MuiOutlinedInput-notchedOutline': { border: 0 },
                                '& .MuiSelect-select': { py: 0.5 },
                                '& .MuiSvgIcon-root': { color: s.ink },
                              }}
                            >
                              {STATUSES.map((opt) => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ fontSize: 13 }}>
                                  <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: opt.dot, mr: 1 }} />
                                  {opt.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <AssigneeStack ids={task.assigneeIds} size={26} max={5} />
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, color: pri.color, fontWeight: 600, fontSize: 13 }}>
                              <pri.Icon sx={{ fontSize: 18 }} />
                              {pri.label}
                            </Box>
                          </TableCell>
                          <TableCell sx={{ color: '#6B6955', fontSize: 13 }}>
                            {done}/{total} items
                          </TableCell>
                          <TableCell sx={{ color: '#6B6955', fontSize: 13 }}>{formatMinutes(task.timeSpentMinutes)}</TableCell>
                          <TableCell sx={{ color: '#6B6955', fontSize: 13 }}>{formatDue(task.dueDate)}</TableCell>
                        </TableRow>
                      )
                    })),
              ]
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}